


import React, { useEffect, useMemo, useState } from "react";
import "./allmembers.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const MembersPage = () => {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(false);

const navigate = useNavigate();
  /* ================= ROLE CHECK ================= */
  const user = JSON.parse(sessionStorage.getItem("user") || "{}");
  const role = (user.role || "").toLowerCase();
  const isTStaff = role === "tstaff";
const [groups, setGroups] = useState([]);
  /* ================= FETCH STUDENTS ================= */
  useEffect(() => {
    const fetchStudents = async () => {
      setLoading(true);

      try {
        const res = await fetch(
          "https://bodhimaram.onrender.com/api/students"
        );

        const data = await res.json();

        setStudents(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("Error fetching students:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchStudents();
  }, []);

  useEffect(() => {
  const fetchGroups = async () => {
    try {
      const res = await axios.get(
        "https://bodhimaram.onrender.com/group/groups"
      );

      setGroups(res.data || []);
    } catch (err) {
      console.error("Error fetching groups:", err);
    }
  };

  fetchGroups();
}, []);
  /* ================= GROUP STUDENTS ================= */
  const groupedStudents = useMemo(() => {
    return students.reduce((groups, student) => {
      const code = student.group_code || "Unknown Group";

      if (!groups[code]) {
        groups[code] = [];
      }

      groups[code].push(student);
      return groups;
    }, {});
  }, [students]);

  const groupColors = [
    "#c7f0f8",
    "#fce4ec",
    "#fff3c7",
    "#e1f7d5",
    "#f8e0c7",
    "#e3d5f7",
  ];

  return (
    <div className="members_container">
      <h2 className="members_title">All Members</h2>

      {loading ? (
        <p>Loading students...</p>
      ) : (
        Object.keys(groupedStudents).map((groupCode, index) => {
          const studentsOfGroup = groupedStudents[groupCode];

          const totalFees = studentsOfGroup.reduce(
            (sum, s) => sum + Number(s.total_fees || 0),
            0
          );
const group = groups.find(
  (g) => g.group_code === groupCode
);

const groupName = group?.name ;
          return (
            <div
              key={groupCode}
              className="group_section"
              style={{
                background:
                  groupColors[index % groupColors.length],
              }}
            >
              <h3 className="group_name">{groupName}</h3>

              {/* ================= MOBILE VIEW ================= */}
              <div className="mobile_students">
                <h3 className="mobile_group_title">
                   {groupName}
                </h3>

                {studentsOfGroup.map((student) => (
                  <div
                    key={student.id}
                    className="student_card"
                  >
                    <div className="avatar">
                      {student.childname?.charAt(0)}
                    </div>

                    <div className="student_info">
                      <h4>{student.childname}</h4>

                      <p>
                        Parent: {student.parentname}
                      </p>

                      <p>
                        Phone: {student.primary_no}
                      </p>
                    </div>

               <div
  className="arrow"
  onClick={() =>
    navigate("/dashboard/member-details", {
      state: { student }
    })
  }
>
  ›
</div>
                  </div>
                ))}
              </div>

              {/* ================= DESKTOP VIEW ================= */}
              <div className="desktop_view">
                <table className="students_table">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Child Name</th>
                      <th>Parent Name</th>
                      <th>Primary No</th>
                      <th>Alternate No</th>

                      {!isTStaff && <th>Fees Type</th>}
                      {!isTStaff && <th>Total Fees</th>}
                      {!isTStaff && <th>Fees Amount</th>}
                      {!isTStaff && <th>Stop Location</th>}
                      {!isTStaff && <th>Cab Monthly</th>}

                      <th>Address</th>
                      <th>Pincode</th>
                      <th>Joining Date</th>
                    </tr>
                  </thead>

                  <tbody>
                    {studentsOfGroup.map((student) => (
                      <tr key={student.id}>
                        <td>{student.st_id}</td>
                        <td>{student.childname}</td>
                        <td>{student.parentname}</td>
                        <td>{student.primary_no}</td>
                        <td>{student.alternate_no}</td>

                        {!isTStaff && (
                          <td>{student.fees_type}</td>
                        )}

                        {!isTStaff && (
                          <td>
                            ₹{student.total_fees}
                          </td>
                        )}

                        {!isTStaff && (
                          <td>
                            ₹{student.fees_amount}
                          </td>
                        )}

                        {!isTStaff && (
                          <td>
                            {student.stop_location}
                          </td>
                        )}

                        {!isTStaff && (
                          <td>
                            ₹
                            {student.cab_monthly_amount}
                          </td>
                        )}

                        <td>{student.address}</td>
                        <td>{student.pincode}</td>
                        <td>{student.joining_date}</td>
                      </tr>
                    ))}

                    {!isTStaff && (
                      <tr className="summary_row">
                        <td colSpan="6">
                          <strong>Total</strong>
                        </td>

                        <td colSpan="2">
                          ₹{totalFees}
                        </td>

                        <td colSpan="4"></td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
};

export default MembersPage;